module.exports = __webpack_public_path__ + "static/media/limpiar-filtros.918f463d.svg";